module.exports = __webpack_public_path__ + "static/media/whats.8cb128aa.webp";